import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  grid: {
    alignContent: "flex-start",
    direction: "row",
    margin: "5%",
  },

  gridContainer: {
    display: "flex",
    justifyContent: "left",
    marginTop: "5%",
  
  },

  footerPin: {
    display: "flex",
    justifyContent: "center",
  },

  image: {
    width: "80%",
  },

  title: {
    fontSize: "4em",
    color: "#000",
    fontWeight: "800",
    fontFamily: "Inter",
    marginRight:"20%",
    marginLeft:"10%",
    lineHeight: 1.3
  },

  subtitle: {
    fontSize: "1.7em",
    color: "#000",
    fontWeight: "400",
    fontFamily: "Inter",
    marginRight:"10%",
    lineHeight: 1.3
  },

  protocolTitle: {
    fontSize: "1.0em",
    color: "#000",
    fontWeight: "400",
    fontFamily: "Inter",
    marginRight:"10%",
    lineHeight: 1.3
  },

  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  leftGrid:{
    marginLeft:"15%"
  },
  rigthGrid:{
    marginLeft:"20%"

  },
  leftStepTitle:{
    fontSize: "1em",
    color: "#000",
    fontWeight: "400",
    fontFamily: "Inter",


    lineHeight: 1.3
  },
  button:{
    marginLeft:"12%",
    marginBottom:'12%',
   
},
link:{
    textDecoration:"none",
},
}));

export { useStyles };
